import clsx from 'clsx';
import { ComponentProps, forwardRef, ReactNode, RefObject } from 'react';

import styles from './Button.module.scss';

export type ButtonProps = Omit<ComponentProps<'button'>, 'children' | 'color'> & {
  ref?: RefObject<HTMLButtonElement>;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  children: ReactNode;
  variant?: 'primary' | 'secondary';
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { className, type = 'button', variant = 'primary', iconLeft, iconRight, children, ...buttonProps } = props;

  return (
    <button
      className={clsx(styles.root, styles[`variant_${variant}`], className)}
      ref={ref}
      type={type}
      {...buttonProps}
    >
      {iconLeft}

      <span>{children}</span>

      {iconRight}
    </button>
  );
});

Button.displayName = 'Button';
